// `updatedAt` might move whenever a child record is saved, even when the record itself did not change.
const IGNORED_KEY = 'updatedAt'

const comparedKeys = (value: object) =>
  Object.keys(value).filter((key) => key !== IGNORED_KEY)

// Structural equality for plain JSON data (wire payloads): primitives, arrays and plain objects.
export const isUnchanged = (a: unknown, b: unknown): boolean => {
  if (Object.is(a, b)) return true
  if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) return false
  if (Array.isArray(a) !== Array.isArray(b)) return false

  const aRecord = a as Record<string, unknown>
  const bRecord = b as Record<string, unknown>
  const keys = comparedKeys(aRecord)
  if (keys.length !== comparedKeys(bRecord).length) return false

  return keys.every(
    (key) => key in bRecord && isUnchanged(aRecord[key], bRecord[key]),
  )
}
